import { getNow, getActiveResources } from '@kathondvla/sri-client/date-utils';
import { sriClient } from 'ReduxLoop/utils/apiConfig';

export const searchOus = async (type) => {
  return sriClient.getRaw('/search', {
    types: 'organisational_unit',
    organisationalUnitTypes: type,
    limit: 20,
  });
};

export const getAllSamOusOfType = async (types, mainstructures) => {
  const ous = await sriClient.getAll('/sam/organisationalunits', {
    typeIn: types.join(','),
    havingMainstructure: mainstructures ? mainstructures.join(',') : undefined,
    endDateAfter: getNow(),
    limit: 5000,
  });

  const mailAddresses = await sriClient.getAll(
    '/sam/organisationalunits/contactdetails',
    {
      type: 'MAIL',
      'organisationalUnit.type': types.join(','),
      limit: 5000,
    },
  );

  const relevantTypes = types.filter((type) => type !== 'SCHOOLENTITY');
  const institutionNumbers = relevantTypes.length ? await sriClient.getAll(
    '/sam/organisationalunits/externalidentifiers',
    {
      type: 'INSTITUTION_NUMBER',
      'organisationalUnit.type': relevantTypes.join(','),
      limit: 5000,
    },
  ) : [];

  return {
    ous,
    mailAddresses,
    identifiers: institutionNumbers,
  };
};

export const getKathOndVlaOusOfType = async (types) => {
  const ous = await sriClient.getAll('/kathondvla/organisationalunits', {
    typeIn: types.join(','),
    endDateAfter: getNow(),
    limit: 5000,
  });

  const mailAddresses = await sriClient.getAll(
    '/kathondvla/organisationalunits/contactdetails',
    {
      type: 'MAIL',
      'organisationalUnit.type': types.join(','),
      limit: 5000,
    },
  );

  const relevantTypes = types.filter((type) => type === 'EXTERN');
  const companyNumbers = relevantTypes.length ? await sriClient.getAll(
    '/kathondvla/organisationalunits/externalidentifiers',
    {
      type: 'COMPANY_NUMBER',
      limit: 5000,
    },
    {
      inBatch: '/kathondvla/organisationalunits/batch',
    }
  ) : [];

  return {
    ous,
    mailAddresses,
    identifiers: companyNumbers,
  };
};

export const getOuByInstitutionNumber = async (institutionNumber) => {
  const results = await sriClient.getAll('/sam/organisationalunits/externalidentifiers', {
    value: institutionNumber,
    expand: 'results.organisationalUnit',
  });
  if (results.length === 0) {
    return null;
  }
  const institutionNumberObject = results[0];
  const ret = { institutionNumber: institutionNumberObject };
  if (institutionNumberObject.organisationalUnit.$$expanded.type === 'SCHOOL') {
    const mainstructureEpds = await sriClient.getAll('/sam/educationalprogrammedetails', {
      hasMainstructure: true,
      organisationalUnit: institutionNumberObject.organisationalUnit.href,
      expand: 'results.mainstructure',
    });
    ret.mainstructures = mainstructureEpds.map((epd) => epd.mainstructure.$$expanded.code.toString());
    if (ret.mainstructures[0].match(/^3/)) {
      const canActRelations = await sriClient.getAll('/sam/organisationalunits/relations', {
        type: 'CAN_ACT_AS',
        to: institutionNumberObject.organisationalUnit.href,
      });
      ret.relatedSchoolEntities = getActiveResources(canActRelations).map((rel) => rel.from.href);
      const mailAddresses = await sriClient.getAll(
        '/sam/organisationalunits/contactdetails',
        {
          type: 'MAIL',
          organisationalUnit: institutionNumberObject.organisationalUnit.href,
          limit: 5000,
        },
      );
      ret.mailAddresses = mailAddresses;
    }
  }
  return ret;
};
